import {DateFormats} from "@/scripts/Common/DateFormats";

export class ReportDownloadModel{
    public Filename:string = '';
    public StartDate:string = '';
    public EndDate:string = '';
    public DateFormat:string = DateFormats.YEAR_MONTH_DAY;
    public Data:any = undefined;
    
    constructor(filename:string, startDate:string, endDate?:string, dateFormat?:string) {
        this.Filename = filename;
        this.StartDate = startDate;
        if(!!endDate){
            this.EndDate = endDate;   
        }
        if(!!dateFormat){
            this.DateFormat = dateFormat;   
        }
    }
}